import React from "react";
import DocList from "../../_components/Purchasing/PurchaseDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiHome, FiSlash } from "react-icons/fi";
import { T, fmtMYR, fmtCurrency } from "../../_components/Purchasing/PurchaseShared";
import {
    getPurchaseDebitNotes,
    getPurchaseDebitNoteKpis,
    deletePurchaseDebitNote,
    getPurchaseDebitNoteById
} from "../../_services/finance.service";

export default function PurchaseDebitNotes() {
    return (
        <DocList
            docType="Purchase Debit Note"
            basePath="/finance/purchase-debit-notes"
            fetchList={getPurchaseDebitNotes}
            bulkPrint={{ fetchById: getPurchaseDebitNoteById }}
            fetchKpis={getPurchaseDebitNoteKpis}
            deleteItem={deletePurchaseDebitNote}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected", "Cancelled"]}
            kpiCards={[
                { label: "Total", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
                { label: "Cancelled", key: "cancelled", icon: FiSlash, color: T.textMuted },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiHome, label: "Supplier", key: "supplier" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiDollarSign, label: "Debit Amount", key: "grandTotal", render: (v, row) => fmtCurrency(v, row.currency) },
            ]}
            totalLabel="Debit Amount"
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "DN No." },
                { key: "date", label: "Date" },
                { key: "supplier", label: "Company Name" },
                { key: "contactPerson", label: "Contact Person" },
            ]}
        />
    );
}